import {
    COVERAGE_DETAIL_INFO_OPEN_MODAL,
    CLEAR_REDUX,
} from "Redux/actionTypes";

const INIT_STATE = {
    loading: false,
    openModal: false,
    details: null
};

export default (state = INIT_STATE, action) => {

    switch (action.type) {
        case COVERAGE_DETAIL_INFO_OPEN_MODAL:
            return { ...state, openModal: true, details: action?.payload?.details }

        case CLEAR_REDUX:
            return ["", "COVERAGE_DETAIL_INFO"].includes(action.payload.option)
                ? action.payload.parameters ? { ...state, ...action.payload.parameters } : { ...INIT_STATE }
                : { ...state }
        default:
            return state;
    }
};